export default "__VITE_ASSET__DP$VyCKv__"